var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var controllers;
    (function (controllers) {
        var SetDataSettingsModalController = /** @class */ (function (_super) {
            __extends(SetDataSettingsModalController, _super);
            function SetDataSettingsModalController($scope, workflowBlock, processConfigId, workflowService, treeService, treeItemService, isReadonly, close) {
                var _this = _super.call(this, $scope, close) || this;
                _this.workflowService = workflowService;
                _this.treeService = treeService;
                _this.treeItemService = treeItemService;
                _this.scope = $scope;
                _this.scope.workflowBlock = workflowBlock;
                _this.scope.isReadonly = isReadonly;
                _this.scope.processConfigId = processConfigId;
                _this.scope.addSetDataOperation = function () { return _this.addSetDataOperation(); };
                _this.scope.deleteSetDataOperation = function (dto) { return _this.deleteSetDataOperation(dto); };
                _this.scope.save = function () { return _this.save(); };
                _this.scope.cancel = function () { return _this.cancel(); };
                return _this;
            }
            SetDataSettingsModalController.prototype.addSetDataOperation = function () {
                var newSetDataOperation = this.workflowService.createNewDataOperation(this.scope.workflowBlock.setDataDto);
            };
            SetDataSettingsModalController.prototype.deleteSetDataOperation = function (dto) {
                this.scope.workflowBlock.setDataDto.mySetDataOperations.remove(dto);
            };
            SetDataSettingsModalController.prototype.save = function () {
                var _this = this;
                // Save all tree item changes that are handled via breeze before trying to save workflow block changes which are all non-breeze
                this.treeItemService.saveAllChanges(function () {
                    _this.dismissModal(true);
                });
            };
            SetDataSettingsModalController.prototype.cancel = function () {
                this.treeItemService.rejectChanges();
                this.dismissModal(false);
            };
            return SetDataSettingsModalController;
        }(controllers.BaseModalController));
        controllers.SetDataSettingsModalController = SetDataSettingsModalController;
    })(controllers = warsApp.controllers || (warsApp.controllers = {}));
})(warsApp || (warsApp = {}));
warsApp.registerController('SetDataSettingsModalController', ['$scope', 'workflowBlock', 'processConfigId', "workflowService", "treeService", "treeItemService", 'isReadonly', 'close']);
